module.exports = __webpack_public_path__ + "img/circle-notch.61cadfd6.svg";